// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuex from 'vuex';
import store from './store'
import 'lib-flexible/flexible';//适配
import Video from 'video.js'//视频
import 'video.js/dist/video-js.css'//视频
import Vant from 'vant'; //UI框架 vant
import 'vant/lib/index.css';//UI框架 vant
import VueAMap from 'vue-amap';//地图
import $ from 'jquery'//jq
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
Vue.use(VueAMap);
Vue.use(Vuex)
Vue.use(Vant)
Vue.prototype.$video = Video
Vue.config.productionTip = false

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '10d0d82a9a5adf4b44764c9351b0a1bf',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js